import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import TeamLogo from '../components/TeamLogo';
import { featuredMatches } from '../data/matches';
import './DashboardPage.css';

const RECENT_BETS = [
  { id: 1, match: 'Man City vs Arsenal',   home: 'Manchester City', away: 'Arsenal',        amount: 50,  odds: 1.85, result: 'won',     profit: +42.5 },
  { id: 2, match: 'PSG vs Marseille',       home: 'PSG',             away: 'Marseille',      amount: 100, odds: 1.60, result: 'won',     profit: +60   },
  { id: 3, match: 'Real Madrid vs Bayern',  home: 'Real Madrid',     away: 'Bayern Munich',  amount: 75,  odds: 2.10, result: 'lost',    profit: -75   },
  { id: 4, match: 'Djokovic vs Alcaraz',    home: 'Djokovic',        away: 'Alcaraz',        amount: 30,  odds: 1.75, result: 'pending', profit: 0     },
  { id: 5, match: 'Barcelona vs Atletico',  home: 'Barcelona',       away: 'Atletico Madrid',amount: 60,  odds: 1.70, result: 'won',     profit: +42   },
];

const WEEK_ACTIVITY = [
  { day: 'Lun', amount: 120 },
  { day: 'Mar', amount: 200 },
  { day: 'Mer', amount: 80  },
  { day: 'Jeu', amount: 310 },
  { day: 'Ven', amount: 150 },
  { day: 'Sam', amount: 380 },
  { day: 'Dim', amount: 240 },
];

const BONUSES = [
  { id: 1, icon: '🎁', title: 'Bonus Bienvenue',  desc: "100% jusqu'à 200€",            expires: '3 jours', color: '#1db954' },
  { id: 2, icon: '⚡', title: 'Boost Cote x1.5',  desc: 'Sur votre prochain pari foot', expires: '1 jour',  color: '#f59e0b' },
  { id: 3, icon: '🏆', title: 'Cashback 10%',     desc: 'Sur paris Champions League',   expires: '5 jours', color: '#2563eb', claimed: true },
];

const LEADERBOARD = [
  { rank: 1, initials: 'JP', name: 'Jean-Paul M.', profit: +2850, medal: '🥇' },
  { rank: 2, initials: 'SA', name: 'Sophie A.',    profit: +1940, medal: '🥈' },
  { rank: 3, initials: 'TK', name: 'Thomas K.',   profit: +1420, medal: '🥉' },
  { rank: 4, initials: 'ML', name: 'Marc L.',      profit: +980,  medal: null },
  { rank: 5, initials: 'CG', name: 'Clara G.',     profit: +760,  medal: null },
];

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Tableau de bord', icon: '🏠' },
  { to: '/sports',    label: 'Paris Sportifs',  icon: '⚽' },
  { to: '/casino',    label: 'Casino',          icon: '🎰' },
  { to: '/wallet',    label: 'Portefeuille',    icon: '💰' },
  { to: '/profil',    label: 'Profil',          icon: '👤' },
  { to: '#',          label: 'Statistiques',    icon: '📊' },
  { to: '#',          label: 'Bonus',           icon: '🎁', badge: '2' },
  { to: '#',          label: 'Paramètres',      icon: '⚙️' },
];

function CircularProgress({ value, size = 56, stroke = 5, color = '#1db954' }) {
  const r = (size - stroke * 2) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (value / 100) * circ;
  return (
    <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="var(--border)" strokeWidth={stroke} />
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={stroke}
        strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"
        style={{ transition: 'stroke-dashoffset 1s ease' }} />
    </svg>
  );
}

export default function DashboardPage({ user, balance = 1500, onLogout }) {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [claimedBonuses, setClaimedBonuses] = useState([]);
  const [quickBet, setQuickBet] = useState(null);

  const displayName = user?.name || 'Joueur';
  const today = new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  const todayCap = today.charAt(0).toUpperCase() + today.slice(1);
  const maxActivity = Math.max(...WEEK_ACTIVITY.map(d => d.amount));

  return (
    <div className="db-root">
      {sidebarOpen && <div className="db-overlay" onClick={() => setSidebarOpen(false)} />}

      {/* ═══ SIDEBAR ═══ */}
      <aside className={`db-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <Link to="/" className="db-sidebar-logo">
          <span className="db-logo-bolt">⚡</span>
          <span className="db-logo-text">Afri<span className="db-logo-accent">Bet</span></span>
        </Link>

        <nav className="db-nav">
          {NAV_ITEMS.map(item => (
            <Link key={item.label} to={item.to}
              className={`db-nav-item ${location.pathname === item.to ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}>
              <span className="db-nav-icon">{item.icon}</span>
              <span className="db-nav-label">{item.label}</span>
              {item.badge && <span className="db-nav-badge">{item.badge}</span>}
            </Link>
          ))}
        </nav>

        <div className="db-sidebar-footer">
          <div className="db-user-row">
            <div className="db-user-avatar">
              {user?.avatar ? <img src={user.avatar} alt={displayName} /> : displayName.charAt(0).toUpperCase()}
            </div>
            <div className="db-user-info">
              <p className="db-user-name">{displayName}</p>
              <p className="db-user-role">Joueur Pro</p>
            </div>
          </div>
          {onLogout
            ? <button className="db-logout" onClick={onLogout}>🚪 Déconnexion</button>
            : <Link to="/" className="db-logout">🚪 Déconnexion</Link>
          }
        </div>
      </aside>

      {/* ═══ MAIN ═══ */}
      <main className="db-main">
        <div className="db-mobile-header">
          <button className="db-hamburger" onClick={() => setSidebarOpen(true)}>☰</button>
          <span className="db-mobile-logo">⚡ Bet<span>Zone</span></span>
        </div>

        <div className="db-content">
          {/* 1. WELCOME */}
          <div className="db-welcome">
            <div className="db-welcome-left">
              <h1 className="db-welcome-title">Bonjour {displayName} 👋</h1>
              <p className="db-welcome-date">{todayCap}</p>
            </div>
            <div className="db-welcome-right">
              <div className="db-balance-chip">
                <span className="db-balance-label">Solde</span>
                <span className="db-balance-value">{balance.toLocaleString('fr-FR')} FC</span>
              </div>
              <Link to="/wallet" className="db-deposit-btn"><span>+</span> Dépôt</Link>
            </div>
          </div>

          {/* 2. STATS GRID */}
          <div className="db-stats-grid">
            <div className="db-stat-card">
              <div className="db-stat-icon-wrap" style={{ background: 'rgba(29,185,84,0.12)' }}>💰</div>
              <div className="db-stat-body">
                <p className="db-stat-label">Solde total</p>
                <p className="db-stat-value" style={{ color: 'var(--accent)' }}>{balance.toLocaleString('fr-FR')} FC</p>
                <span className="db-stat-trend db-trend-up">↑ +12%</span>
              </div>
            </div>
            <div className="db-stat-card">
              <div className="db-stat-icon-wrap" style={{ background: 'rgba(37,99,235,0.12)' }}>🎯</div>
              <div className="db-stat-body">
                <p className="db-stat-label">Paris ce mois</p>
                <p className="db-stat-value" style={{ color: 'var(--blue)' }}>24</p>
                <span className="db-stat-trend db-trend-up">↑ +3 vs mois dernier</span>
              </div>
            </div>
            <div className="db-stat-card db-stat-rate">
              <div className="db-stat-ring">
                <CircularProgress value={67} size={56} stroke={5} color="#1db954" />
                <span className="db-stat-ring-value">67%</span>
              </div>
              <div className="db-stat-body">
                <p className="db-stat-label">Taux de réussite</p>
                <p className="db-stat-value" style={{ color: 'var(--accent)' }}>67%</p>
                <span className="db-stat-trend db-trend-up">↑ Meilleur ce mois</span>
              </div>
            </div>
            <div className="db-stat-card">
              <div className="db-stat-icon-wrap" style={{ background: 'rgba(29,185,84,0.12)' }}>📈</div>
              <div className="db-stat-body">
                <p className="db-stat-label">Profit total</p>
                <p className="db-stat-value" style={{ color: 'var(--accent)' }}>+142 FC</p>
                <span className="db-stat-trend db-trend-up">↑ Positif !</span>
              </div>
            </div>
          </div>

          {/* 3. MIDDLE ROW */}
          <div className="db-mid-row">
            <div className="db-card db-recent-bets">
              <div className="db-card-header">
                <h2 className="db-card-title">Paris récents</h2>
                <Link to="/sports" className="db-card-link">Voir tout →</Link>
              </div>
              <div className="db-bets-table">
                {RECENT_BETS.map(bet => (
                  <div key={bet.id} className="db-bet-row">
                    <div className="db-bet-teams">
                      <TeamLogo team={bet.home} size={26} />
                      <div className="db-bet-info">
                        <span className="db-bet-match">{bet.match}</span>
                        <span className="db-bet-odds">Cote {bet.odds}</span>
                      </div>
                      <TeamLogo team={bet.away} size={26} />
                    </div>
                    <div className="db-bet-right">
                      <span className="db-bet-amount">{bet.amount} FC</span>
                      <span className={`db-bet-chip db-chip-${bet.result}`}>
                        {bet.result === 'won' ? '✓ Gagné' : bet.result === 'lost' ? '✗ Perdu' : '⏳ En cours'}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="db-card db-activity">
              <div className="db-card-header">
                <h2 className="db-card-title">Activité (7 jours)</h2>
                <span className="db-card-sub">Montant misé en FC</span>
              </div>
              <div className="db-bar-chart">
                {WEEK_ACTIVITY.map(d => (
                  <div key={d.day} className="db-bar-col">
                    <div className="db-bar-wrap">
                      <div className="db-bar" style={{ height: `${(d.amount / maxActivity) * 100}%` }}>
                        <div className="db-bar-tooltip">{d.amount}€</div>
                      </div>
                    </div>
                    <span className="db-bar-label">{d.day}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 4. BOTTOM ROW */}
          <div className="db-bottom-row">
            <div className="db-card db-matches">
              <div className="db-card-header">
                <h2 className="db-card-title">Matchs à la une</h2>
                <Link to="/sports" className="db-card-link">Tous →</Link>
              </div>
              <div className="db-matches-list">
                {featuredMatches.slice(0, 3).map(match => {
                  const home = match.markets?.home ?? match.odds?.find(o => o.selection === 'Home')?.odd_value;
                  const draw = match.markets?.draw ?? match.odds?.find(o => o.selection === 'Draw')?.odd_value;
                  const away = match.markets?.away ?? match.odds?.find(o => o.selection === 'Away')?.odd_value;
                  const ht   = match.homeTeam ?? match.home_team ?? '';
                  const at   = match.awayTeam ?? match.away_team ?? '';
                  const lf   = match.leagueFlag ?? '';
                  const lg   = match.league ?? '';
                  const dt   = match.date ?? match.match_date ?? '';
                  return (
                    <div key={match.id} className="db-match-item">
                      <div className="db-match-info">
                        <span className="db-match-league">{lf} {lg}</span>
                        <div className="db-match-teams">
                          <span>{ht}</span>
                          <span className="db-match-vs">vs</span>
                          <span>{at}</span>
                        </div>
                        <span className="db-match-time">{dt}</span>
                      </div>
                      <div className="db-match-odds">
                        {home != null && (
                          <button className={`db-odd-btn ${quickBet === `${match.id}-1` ? 'selected' : ''}`}
                            onClick={() => setQuickBet(quickBet === `${match.id}-1` ? null : `${match.id}-1`)}>
                            <span className="db-odd-label">1</span>
                            <span className="db-odd-val">{home}</span>
                          </button>
                        )}
                        {draw != null && (
                          <button className={`db-odd-btn ${quickBet === `${match.id}-x` ? 'selected' : ''}`}
                            onClick={() => setQuickBet(quickBet === `${match.id}-x` ? null : `${match.id}-x`)}>
                            <span className="db-odd-label">X</span>
                            <span className="db-odd-val">{draw}</span>
                          </button>
                        )}
                        {away != null && (
                          <button className={`db-odd-btn ${quickBet === `${match.id}-2` ? 'selected' : ''}`}
                            onClick={() => setQuickBet(quickBet === `${match.id}-2` ? null : `${match.id}-2`)}>
                            <span className="db-odd-label">2</span>
                            <span className="db-odd-val">{away}</span>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="db-card db-bonuses">
              <div className="db-card-header">
                <h2 className="db-card-title">Bonus disponibles</h2>
                <span className="db-bonus-count">{BONUSES.filter(b => !b.claimed).length} actifs</span>
              </div>
              <div className="db-bonus-list">
                {BONUSES.map(bonus => {
                  const isClaimed = bonus.claimed || claimedBonuses.includes(bonus.id);
                  return (
                    <div key={bonus.id} className={`db-bonus-card ${isClaimed ? 'claimed' : ''}`}
                      style={{ '--bonus-color': bonus.color }}>
                      <div className="db-bonus-icon">{bonus.icon}</div>
                      <div className="db-bonus-body">
                        <p className="db-bonus-title">{bonus.title}</p>
                        <p className="db-bonus-desc">{bonus.desc}</p>
                        {!isClaimed && <span className="db-bonus-expires">Expire dans {bonus.expires}</span>}
                      </div>
                      <button className={`db-bonus-btn ${isClaimed ? 'used' : ''}`}
                        onClick={() => !isClaimed && setClaimedBonuses(p => [...p, bonus.id])}
                        disabled={isClaimed}>
                        {isClaimed ? '✓' : 'Activer'}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="db-card db-leaderboard">
              <div className="db-card-header">
                <h2 className="db-card-title">Classement</h2>
                <span className="db-card-sub">Top joueurs</span>
              </div>
              <div className="db-lb-list">
                {LEADERBOARD.map(player => (
                  <div key={player.rank} className={`db-lb-row ${player.rank <= 3 ? 'top3' : ''}`}>
                    <div className="db-lb-rank">
                      {player.medal ? <span className="db-lb-medal">{player.medal}</span> : <span className="db-lb-num">{player.rank}</span>}
                    </div>
                    <div className="db-lb-avatar">{player.initials}</div>
                    <div className="db-lb-info"><p className="db-lb-name">{player.name}</p></div>
                    <div className={`db-lb-profit ${player.profit >= 0 ? 'pos' : 'neg'}`}>
                      {player.profit >= 0 ? '+' : ''}{player.profit.toLocaleString('fr-FR')} FC
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
